<template>
  <div class="detail">
    <el-form
      label-position="right"
      ref="form"
      size="small"
      :model="ruleForm"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="企业名称">
            <el-input placeholder="请填写企业名称" v-model="ruleForm.enterpriseName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="组织机构代码">
            <el-input
              placeholder="请填写组织机构代码"
              v-model="ruleForm.organizationCode"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="企业法人">
            <el-input placeholder="请填写企业法人" v-model="ruleForm.legalPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="联系方式">
            <el-input placeholder="请填写联系方式" v-model="ruleForm.legalPersonPhone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="财务负责人">
            <el-input placeholder="请填写财务负责人" v-model="ruleForm.financialLeader"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="联系方式">
            <el-input
              placeholder="请填写联系方式"
              v-model="ruleForm.financialLeaderPhone"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="联系人">
            <el-input placeholder="请填写联系人" v-model="ruleForm.contactPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="联系方式">
            <el-input placeholder="请填写联系方式" v-model="ruleForm.contactPersonPhone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="成立时间">
            <el-date-picker
              v-model="ruleForm.establishDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="纳税地点">
            <el-input placeholder="请填写纳税地点" v-model="ruleForm.taxLocation"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="注册地址">
            <el-input
              size="small"
              label-width="0"
              placeholder="请填写注册地址"
              v-model="ruleForm.registeredAddressStr"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-input
              size="small"
              label-width="0"
              placeholder="请填写详细地址"
              v-model="ruleForm.registeredAddressDetail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="实际地址">
            <el-input
              size="small"
              label-width="0"
              placeholder="请填写实际地址"
              v-model="ruleForm.physicalAddressStr"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-input
              size="small"
              label-width="0"
              placeholder="请填写详细地址"
              v-model="ruleForm.physicalAddressDetail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="所属区域">
            <el-input
              size="small"
              label-width="0"
              placeholder="请填写所属区域"
              v-model="ruleForm.areaStr"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="所属行业">
            <el-input
              size="small"
              label-width="0"
              placeholder="请填写所属行业"
              v-model="ruleForm.industryStr"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="主要经营产品">
            <el-input
              size="small"
              placeholder="请填写主要经营产品"
              v-model="ruleForm.mainProduct"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="120px" label="上年度末总资产">
            <el-input
              size="small"
              placeholder="请填写上年度末总资产"
              v-model="ruleForm.lastYearTotalAssets"
            >
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label-width="120px" label="上年度销售收入">
            <el-input
              size="small"
              placeholder="请填写上年度销售收入"
              v-model="ruleForm.lastYearSalesRevenue"
            >
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="自主知识产权数量" prop="independentRightCount" label-width="140px">
            <el-input
              v-model="ruleForm.independentRightCount"
              placeholder="请填写自主知识产权数量"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label-width="125px" label="公司简介" prop="introduction">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              placeholder=" 请填写公司简介"
              v-model="ruleForm.introduction"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import { regionData, CodeToText, TextToCode } from 'element-china-area-data';
export default {
  props: ['dataList', 'disabled'],
  data() {
    return {
      rules: {},
      addroptions: regionData,
      businessOptions: [
        {
          value: 1,
          label: '农业与化工'
        },
        {
          value: 2,
          label: '生物与医药'
        },
        {
          value: 3,
          label: '能源与采矿'
        },
        {
          value: 4,
          label: '建筑与水利'
        },
        {
          value: 5,
          label: '交通与运输'
        },
        {
          value: 6,
          label: '自然与社科'
        }
      ],
      ruleForm: {},
      industry: null,
    }
  },
  created() {
    console.log(this.dataList,'dataList')
    if(this.dataList) {
      this.getFormValue(this.dataList);
    }
  },
  watch: {
    dataList(val) {
      if(val) {
      console.log('valvalval', val)
        this.getFormValue(val)
      }
    }
  },
  methods: {
    getFormValue(data) {
      console.log(data,'datadatadatadata')
      if(data.area) {
        // const area = JSON.parse(data.area);
        // data.areaStr = data.area.join(',')
        // data.areaStr = JSON.parse(data.area)
        data.areaStr = Array.isArray(data.area) ? (data.area.join('')) : data.area
      }
      if(data.physicalAddress) {
        // const physicalAddress = JSON.parse(data.physicalAddress);
        // data.physicalAddressStr = data.physicalAddress.join(',');
        // data.physicalAddressStr = JSON.parse(data.physicalAddress)
        data.physicalAddressStr = Array.isArray(data.physicalAddress) ? (data.physicalAddress.join('')) : data.physicalAddress
      }
      if(data.registeredAddress) {
        // const registeredAddress = JSON.parse(data.registeredAddress);
        // data.registeredAddressStr = data.registeredAddress.join(',');
        // data.registeredAddressStr = JSON.parse(data.registeredAddress)
        data.registeredAddressStr = Array.isArray(data.registeredAddress) ? (data.registeredAddress.join('')) : data.registeredAddress
      }
      if(data.industry) {
        // var industry = JSON.parse(data.industry).label;
        data.industryStr = data.industry.label;
        // data.industryStr = JSON.parse(data.industry)?.label || ""
      }
      this.ruleForm = {
        ...data
      }
    },
    selectChange(val) {
      this.industry = this.businessOptions.find(item => item.value === val)
    },
    getAreaCode(list) {
      if(list && list.length > 2) {
        let dataList = [];
        if (TextToCode[list[0]]) {
          dataList = [TextToCode[list[0]].code, TextToCode[list[0]][list[1]].code, TextToCode[list[0]][list[1]][list[2]].code];
        }
        return dataList
      }
      return ''
    },
    parentHandleclick(e) {
      this.$refs.form.validate((val) => {
        if (val) {
          const area = this.ruleForm.area ? JSON.stringify([CodeToText[this.ruleForm.area[0]],CodeToText[this.ruleForm.area[1]],CodeToText[this.ruleForm.area[2]]]): '';
          const physicalAddress = this.ruleForm.physicalAddress ? JSON.stringify([CodeToText[this.ruleForm.physicalAddress[0]],CodeToText[this.ruleForm.physicalAddress[1]],CodeToText[this.ruleForm.physicalAddress[2]]]): '';
          const registeredAddress = this.ruleForm.registeredAddress ? JSON.stringify([CodeToText[this.ruleForm.registeredAddress[0]], CodeToText[this.ruleForm.registeredAddress[1]],CodeToText[this.ruleForm.registeredAddress[2]]]): '';
          const params = {
            ...this.ruleForm,
            area,
            industry: this.industry ? JSON.stringify(this.industry): '',
            physicalAddress,
            registeredAddress,
          }
          e && e(params)
        }
      });
    }
  }
}
</script>
<style lang="sass" scoped></style>
